import { render } from "./ConversionOdaxBlock.vue?vue&type=template&id=7931c06a"
import script from "./ConversionOdaxBlock.vue?vue&type=script&lang=js"
export * from "./ConversionOdaxBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/ConversionOdaxBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7931c06a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7931c06a', __exports__)) {
    api.reload('7931c06a', __exports__)
  }
  
  module.hot.accept("./ConversionOdaxBlock.vue?vue&type=template&id=7931c06a", () => {
    api.rerender('7931c06a', render)
  })

}


export default __exports__